import {
  GET_LOCATION_RULES,
  GET_LOCATION_RULES_SUCCESS,
  GET_LOCATION_RULES_FAILURE,
  CREATE_LOCATION_RULE,
  CREATE_LOCATION_RULE_SUCCESS,
  CREATE_LOCATION_RULE_FAILURE,
  UPDATE_LOCATION_RULE,
  UPDATE_LOCATION_RULE_SUCCESS,
  UPDATE_LOCATION_RULE_FAILURE,
  DELETE_LOCATION_RULE,
  DELETE_LOCATION_RULE_SUCCESS,
  DELETE_LOCATION_RULE_FAILURE,
  RESCRAPE_LOCATION_RULE,
  RESCRAPE_LOCATION_RULE_SUCCESS,
  RESCRAPE_LOCATION_RULE_FAILURE,
} from "./constants";

export const getLocationRules = (payload, onSuccess) => ({
  type: GET_LOCATION_RULES,
  payload,
  onSuccess,
});
export const getLocationRulesSuccess = (payload) => ({
  type: GET_LOCATION_RULES_SUCCESS,
  payload,
});
export const getLocationRulesFailure = () => ({
  type: GET_LOCATION_RULES_FAILURE,
});

export const createLocationRule = (payload, onSuccess) => ({
  type: CREATE_LOCATION_RULE,
  payload,
  onSuccess,
});
export const createLocationRuleSuccess = (payload) => ({
  type: CREATE_LOCATION_RULE_SUCCESS,
  payload,
});
export const createLocationRuleFailure = () => ({
  type: CREATE_LOCATION_RULE_FAILURE,
});

export const updateLocationRule = (payload, onSuccess) => ({
  type: UPDATE_LOCATION_RULE,
  payload,
  onSuccess,
});
export const updateLocationRuleSuccess = (payload) => ({
  type: UPDATE_LOCATION_RULE_SUCCESS,
  payload,
});
export const updateLocationRuleFailure = () => ({
  type: UPDATE_LOCATION_RULE_FAILURE,
});

export const deleteLocationRule = (payload, onSuccess) => ({
  type: DELETE_LOCATION_RULE,
  payload,
  onSuccess,
});
export const deleteLocationRuleSuccess = (payload) => ({
  type: DELETE_LOCATION_RULE_SUCCESS,
  payload,
});
export const deleteLocationRuleFailure = () => ({
  type: DELETE_LOCATION_RULE_FAILURE,
});

export const rescrapeLocationRule = (payload, onSuccess) => ({
  type: RESCRAPE_LOCATION_RULE,
  payload,
  onSuccess,
});
export const rescrapeLocationRuleSuccess = (payload) => ({
  type: RESCRAPE_LOCATION_RULE_SUCCESS,
  payload,
});
export const rescrapeLocationRuleFailure = () => ({
  type: RESCRAPE_LOCATION_RULE_FAILURE,
});
